/* ADEPSIA — interactions partagées (menu mobile, FAQ, onglets, galerie, sticky, sélecteur peau) */
(function () {
  function init() {
    /* ===== Menu mobile ===== */
    var toggle = document.querySelector('.nav-toggle');
    var menu = document.getElementById('mobile-menu');
    if (toggle && menu) {
      var setOpen = function (open) {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute('aria-label', open ? toggle.dataset.labelClose : toggle.dataset.labelOpen);
        menu.hidden = false;
        void menu.offsetWidth;
        menu.classList.toggle('open', open);
        document.body.style.overflow = open ? 'hidden' : '';
      };
      toggle.addEventListener('click', function () {
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });
      menu.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { setOpen(false); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') setOpen(false);
      });
    }

    /* ===== FAQ accordéon ===== */
    document.querySelectorAll('.faq-q').forEach(function (q) {
      if (q.dataset.bound) return;
      q.dataset.bound = '1';
      q.setAttribute('aria-expanded', q.parentElement.classList.contains('open') ? 'true' : 'false');
      q.addEventListener('click', function () {
        var open = q.parentElement.classList.toggle('open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* ===== Sélecteur type de peau ===== */
    var cards = document.querySelectorAll('.skin-card');
    if (cards.length) {
      var drawers = document.querySelectorAll('.skin-drawer-wrap');
      var closeAll = function () {
        drawers.forEach(function (d) { d.classList.remove('is-open'); });
        cards.forEach(function (c) { c.setAttribute('aria-selected', 'false'); });
      };
      cards.forEach(function (card) {
        if (card.dataset.bound) return;
        card.dataset.bound = '1';
        card.addEventListener('click', function () {
          var target = card.getAttribute('data-target');
          var drawer = document.getElementById(target);
          if (!drawer) return;
          var isOpen = drawer.classList.contains('is-open');
          closeAll();
          if (!isOpen) {
            drawer.classList.add('is-open');
            card.setAttribute('aria-selected', 'true');
            setTimeout(function () { drawer.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 50);
          }
        });
      });
      document.querySelectorAll('.skin-drawer-close').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-close');
          var d = document.getElementById(target);
          if (d) d.classList.remove('is-open');
          var card = document.querySelector('[data-target="' + target + '"]');
          if (card) card.setAttribute('aria-selected', 'false');
        });
      });
    }

    /* ===== Onglets produit ===== */
    var tabBtns = document.querySelectorAll('.tabs-row button');
    if (tabBtns.length) {
      tabBtns.forEach(function (b) {
        if (b.dataset.bound) return;
        b.dataset.bound = '1';
        b.addEventListener('click', function () {
          tabBtns.forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
          document.querySelectorAll('.tab-panel').forEach(function (p) { p.classList.remove('on'); });
          b.setAttribute('aria-selected', 'true');
          var panel = document.querySelector('.tab-panel[data-panel="' + b.dataset.tab + '"]');
          if (panel) panel.classList.add('on');
        });
      });
    }

    /* ===== Galerie produit (vignettes + flèches) ===== */
    var heroImg = document.getElementById('hero-img');
    var thumbBtns = Array.prototype.slice.call(document.querySelectorAll('.thumbs button'));
    if (heroImg && thumbBtns.length && !heroImg.dataset.bound) {
      heroImg.dataset.bound = '1';
      var defaultHeroAlt = heroImg.alt;
      var defaultHeroFit = heroImg.style.objectFit;
      var currentIndex = function () {
        var i = thumbBtns.findIndex(function (b) { return b.getAttribute('aria-current') === 'true'; });
        return i < 0 ? 0 : i;
      };
      var selectIndex = function (i) {
        var n = thumbBtns.length;
        i = ((i % n) + n) % n;
        thumbBtns.forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        var t = thumbBtns[i];
        t.setAttribute('aria-current', 'true');
        if (t.dataset.src) heroImg.src = t.dataset.src;
        heroImg.alt = t.dataset.alt || defaultHeroAlt;
        heroImg.style.objectFit = t.dataset.fit || defaultHeroFit;
      };
      thumbBtns.forEach(function (t, i) { t.addEventListener('click', function () { selectIndex(i); }); });
      var prevArrow = document.querySelector('.gal-arrow.prev');
      var nextArrow = document.querySelector('.gal-arrow.next');
      if (prevArrow) prevArrow.addEventListener('click', function () { selectIndex(currentIndex() - 1); });
      if (nextArrow) nextArrow.addEventListener('click', function () { selectIndex(currentIndex() + 1); });
    }

    /* ===== Sticky CTA (page produit) ===== */
    var sticky = document.getElementById('sticky');
    var capture = document.getElementById('capture');
    if (sticky && capture && !sticky.dataset.bound) {
      sticky.dataset.bound = '1';
      window.addEventListener('scroll', function () {
        var r = capture.getBoundingClientRect();
        var past = r.bottom < 0;
        var atFooter = (window.innerHeight + window.scrollY) > (document.body.offsetHeight - 260);
        sticky.classList.toggle('on', past && !atFooter);
      }, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Ré-initialisation dans l'éditeur de thème Shopify (ajout / modif / réordonnancement de section) */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();
